import { NestedCSSProperties } from 'typestyle/lib/types';
import { media } from 'typestyle';
import {
  largeMobileBreakpoint,
  desktopBreakpoint,
  smallTabletBreakpoint,
  largeTabletBreakpoint,
  mediumDesktopBreakpoint,
  CommonDesktopBreakpoint,
  wideDesktopBreakpoint,
  smallMobileBreakpoint,
} from '../config';
import { EnvModel } from '../../../modules/env/model';
import {
  tracklineBreakpoint2XS,
  tracklineBreakpointXS,
  tracklineBreakpointSM,
  tracklineBreakpointMD,
  tracklineBreakpointLG,
  tracklineBreakpointXL,
  tracklineBreakpoint2XL,
} from '../../../theme/constant';

export const mediaUpToLargeMobile = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ maxWidth: largeMobileBreakpoint - 1 }, ...styles);
export const mediaLargeMobileOnly = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ minWidth: largeMobileBreakpoint, maxWidth: smallTabletBreakpoint - 1 }, ...styles);
export const mediaLargeMobile = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ minWidth: largeMobileBreakpoint }, ...styles);

export const mediaMobileOnly = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ maxWidth: smallTabletBreakpoint - 1 }, ...styles);

export const mediaSmallMobileOnly = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ maxWidth: smallMobileBreakpoint - 1 }, ...styles);

export const mediaUpToSmallTablet = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ maxWidth: smallTabletBreakpoint - 1 }, ...styles);
export const mediaSmallTabletOnly = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ minWidth: smallTabletBreakpoint, maxWidth: largeTabletBreakpoint - 1 }, ...styles);
export const mediaSmallTablet = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ minWidth: smallTabletBreakpoint }, ...styles);

export const mediaUpToLargeTablet = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ maxWidth: largeTabletBreakpoint - 1 }, ...styles);
export const mediaLargeTabletOnly = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ minWidth: largeTabletBreakpoint, maxWidth: desktopBreakpoint - 1 }, ...styles);
export const mediaLargeTablet = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ minWidth: largeTabletBreakpoint }, ...styles);

export const mediaUpToDesktop = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ maxWidth: desktopBreakpoint - 1 }, ...styles);
export const mediaDesktopOnly = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ minWidth: desktopBreakpoint, maxWidth: mediumDesktopBreakpoint - 1 }, ...styles);
export const mediaDesktop = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ minWidth: desktopBreakpoint }, ...styles);

export const mediaUpToMediumDesktop = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ maxWidth: mediumDesktopBreakpoint - 1 }, ...styles);
export const mediaMediumDesktopOnly = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ minWidth: mediumDesktopBreakpoint, maxWidth: wideDesktopBreakpoint - 1 }, ...styles);
export const mediaMediumDesktop = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ minWidth: mediumDesktopBreakpoint }, ...styles);

export const mediaUpToWideDesktop = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ maxWidth: wideDesktopBreakpoint - 1 }, ...styles);
export const mediaWideDesktopOnly = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ minWidth: wideDesktopBreakpoint, maxWidth: CommonDesktopBreakpoint - 1 }, ...styles);
export const mediaWideDesktop = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ minWidth: wideDesktopBreakpoint }, ...styles);

export const mediaLargeDesktop = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ minWidth: CommonDesktopBreakpoint }, ...styles);

export const mediaBetweenWideAndLargeDesktop = (...styles: NestedCSSProperties[]): NestedCSSProperties =>
  media({ minWidth: wideDesktopBreakpoint, maxWidth: CommonDesktopBreakpoint - 1 }, ...styles);

// Trackline container queries
export const containerUpToTrackline2XS = (containerName: string): string =>
  `@container ${containerName} (max-width: ${tracklineBreakpoint2XS - 1}px)`;
export const containerTrackline2XS = (containerName: string): string =>
  `@container ${containerName} (min-width: ${tracklineBreakpoint2XS}px)`;

export const containerUpToTracklineXS = (containerName: string): string =>
  `@container ${containerName} (max-width: ${tracklineBreakpointXS - 1}px)`;
export const containerTracklineXS = (containerName: string): string =>
  `@container ${containerName} (min-width: ${tracklineBreakpointXS}px)`;

export const containerUpToTracklineSM = (containerName: string): string =>
  `@container ${containerName} (max-width: ${tracklineBreakpointSM - 1}px)`;
export const containerTracklineSM = (containerName: string): string =>
  `@container ${containerName} (min-width: ${tracklineBreakpointSM}px)`;

export const containerUpToTracklineMD = (containerName: string): string =>
  `@container ${containerName} (max-width: ${tracklineBreakpointMD - 1}px)`;
export const containerTracklineMD = (containerName: string): string =>
  `@container ${containerName} (min-width: ${tracklineBreakpointMD}px)`;

export const containerUpToTracklineLG = (containerName: string): string =>
  `@container ${containerName} (max-width: ${tracklineBreakpointLG - 1}px)`;
export const containerTracklineLG = (containerName: string): string =>
  `@container ${containerName} (min-width: ${tracklineBreakpointLG}px)`;

export const containerUpToTracklineXL = (containerName: string): string =>
  `@container ${containerName} (max-width: ${tracklineBreakpointXL - 1}px)`;
export const containerTracklineXL = (containerName: string): string =>
  `@container ${containerName} (min-width: ${tracklineBreakpointXL}px)`;

export const containerUpToTrackline2XL = (containerName: string): string =>
  `@container ${containerName} (max-width: ${tracklineBreakpoint2XL - 1}px)`;
export const containerTrackline2XL = (containerName: string): string =>
  `@container ${containerName} (min-width: ${tracklineBreakpoint2XL}px)`;

type SomeMatchMediaProperties = Pick<
  MediaQueryList & EventTarget,
  'matches' | 'addEventListener' | 'removeEventListener'
>;
const dummyMatchMediaObject = {
  matches: true,
  addEventListener: () => void 0,
  removeEventListener: () => void 0,
};
let isDesktop: SomeMatchMediaProperties = dummyMatchMediaObject;
let isFinePointer: SomeMatchMediaProperties = dummyMatchMediaObject;
let isMobileUpToDesktop: SomeMatchMediaProperties = dummyMatchMediaObject;
let isMediumDesktop: SomeMatchMediaProperties = dummyMatchMediaObject;

if (!EnvModel.isServer) {
  // The original MediaQueryList didn't inherit from EventTarget, so TypeScript complains, we shim that in matchMedia-shim.js so this is fine
  isDesktop = (window.matchMedia(`(min-width:  ${desktopBreakpoint}px)`) as any) as SomeMatchMediaProperties;
  isMediumDesktop = (window.matchMedia(
    `(min-width:  ${mediumDesktopBreakpoint}px)`
  ) as any) as SomeMatchMediaProperties;

  isFinePointer = (window.matchMedia('(pointer:fine)') as any) as SomeMatchMediaProperties;
  isMobileUpToDesktop = (window.matchMedia(
    `(max-width:  ${desktopBreakpoint - 1}px)`
  ) as any) as SomeMatchMediaProperties;
}
export { isDesktop, isFinePointer, isMobileUpToDesktop, isMediumDesktop };
